import React, { useEffect, useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  name: 'Valentina M.',
  city: 'Bogotá',
  text: 'Al quinto día mi hijo durmió 5 horas seguidas por primera vez. Lloré de felicidad.',
  rating: 5,
  initials: 'VM',
  color: 'bg-primary-100 text-primary-600'
}, {
  name: 'Andrés F.',
  city: 'Medellín',
  text: 'Nos salvó la relación. Dejamos de pelearnos por los turnos de la noche.',
  rating: 5,
  initials: 'AF',
  color: 'bg-green-100 text-green-600'
}, {
  name: 'Carolina R.',
  city: 'Cali',
  text: 'El método de bloqueo sonoro funcionó desde el día 3. Los buses ya no despiertan al bebé.',
  rating: 5,
  initials: 'CR',
  color: 'bg-purple-100 text-purple-600'
}, {
  name: 'Mariana P.',
  city: 'Bucaramanga',
  text: 'En 5 días dejé de improvisar y empecé a confiar en el sistema.',
  rating: 5,
  initials: 'MP',
  color: 'bg-pink-100 text-pink-600'
}, {
  name: 'Daniela S.',
  city: 'Barranquilla',
  text: 'Pasamos de 5 despertares a solo 1. Los ritmos tropicales fueron la clave.',
  rating: 5,
  initials: 'DS',
  color: 'bg-amber-100 text-amber-600'
}, {
  name: 'Camilo T.',
  city: 'Pereira',
  text: 'Yo mismo me encargué de la rutina. Funciona perfecto en nuestro apartamento pequeño.',
  rating: 5,
  initials: 'CT',
  color: 'bg-teal-100 text-teal-600'
}];
export function TestimonialSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const itemsPerView = isMobile ? 1 : 3;
  const maxIndex = Math.max(0, testimonials.length - itemsPerView);
  const next = () => setCurrentIndex(prev => Math.min(prev + 1, maxIndex));
  const prev = () => setCurrentIndex(prev => Math.max(prev - 1, 0));
  return <section className="py-12 md:py-16 bg-warm-100 overflow-hidden" data-id="element-262">
      <div className="max-w-6xl mx-auto px-4" data-id="element-263">
        <div className="text-center mb-10" data-id="element-264">
          <h2 className="text-2xl md:text-3xl font-bold text-text-dark mb-2" data-id="element-265">
            Historias de familias como la tuya
          </h2>
          <p className="text-sm text-text-muted" data-id="element-266">* Resultados pueden variar</p>
        </div>

        <div className="relative" data-id="element-267">
          {/* Navigation Arrows */}
          <button onClick={prev} disabled={currentIndex === 0} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-2 md:-ml-6 z-10 bg-white p-2 rounded-full shadow-md text-text-dark disabled:opacity-30 disabled:cursor-not-allowed hover:bg-warm-50 transition-colors" aria-label="Anterior" data-id="element-268">
            <ChevronLeft className="w-6 h-6" data-id="element-269" />
          </button>

          <button onClick={next} disabled={currentIndex === maxIndex} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-2 md:-mr-6 z-10 bg-white p-2 rounded-full shadow-md text-text-dark disabled:opacity-30 disabled:cursor-not-allowed hover:bg-warm-50 transition-colors" aria-label="Siguiente" data-id="element-270">
            <ChevronRight className="w-6 h-6" data-id="element-271" />
          </button>

          {/* Slider Container */}
          <div className="overflow-hidden px-2 py-4" data-id="element-272">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)`
          }} data-id="element-273">
              {testimonials.map((t, idx) => <div key={idx} className="flex-shrink-0 px-3" style={{
              width: `${100 / itemsPerView}%`
            }} data-id="element-274">
                  <div className="bg-white p-6 rounded-2xl shadow-sm h-full flex flex-col" data-id="element-275">
                    <div className="flex items-center gap-4 mb-4" data-id="element-276">
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-base ${t.color}`} data-id="element-277">
                        {t.initials}
                      </div>
                      <div data-id="element-278">
                        <h4 className="font-semibold text-text-dark" data-id="element-279">
                          {t.name}
                        </h4>
                        <p className="text-xs text-text-muted" data-id="element-280">{t.city}</p>
                      </div>
                    </div>
                    <div className="flex gap-1 mb-3" data-id="element-281">
                      {[1, 2, 3, 4, 5].map(star => <Star key={star} className={`w-4 h-4 ${star <= t.rating ? 'fill-gold-500 text-gold-500' : 'text-warm-200'}`} data-id="element-282" />)}
                    </div>
                    <p className="text-text-body text-sm leading-relaxed flex-1" data-id="element-283">
                      "{t.text}"
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-284">
            {Array.from({
            length: maxIndex + 1
          }).map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-colors ${currentIndex === idx ? 'bg-primary-500' : 'bg-warm-300 hover:bg-warm-400'}`} aria-label={`Ir a la diapositiva ${idx + 1}`} data-id="element-285" />)}
          </div>
        </div>
      </div>
    </section>;
}